import { render, staticRenderFns } from "./CountDown.vue?vue&type=template&id=567d5071&scoped=true&"
import script from "./CountDown.vue?vue&type=script&lang=js&"
export * from "./CountDown.vue?vue&type=script&lang=js&"
import style0 from "./CountDown.vue?vue&type=style&index=0&id=567d5071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567d5071",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
